<template>
    <div class="home row">
        <Sidebar :mainBudget="mainBudget" />
        <div class="content col-sm-9">
            <h1>{{ mainBudget.when }} {{ mainBudget.type }} Budget</h1>
            <Nav :departments="departments" :mainBudget="mainBudget" />
            
            <template v-if="summary">
                <h3>Budget Overview</h3>
                <p v-html="summary" />
            </template>
            <p><a href="//www.seattle.gov/budget/">www.seattle.gov/budget</a></p>
        </div>
    </div>
</template>

<script>
    import Nav from '@/components/Nav';
    import Sidebar from '@/components/Sidebar';

    export default {
        name: 'home',
        props: {
            'mainBudget' : Object,
            'departments' : Array, 
        },
        computed: {
            summary: function(){
                return (this.mainBudget.overview && this.mainBudget.overview.summary) ? this.mainBudget.overview.summary : ''
            }
        },
        components: {
            Nav,
            Sidebar
        }
    }
</script>
